import { BucketsTable } from "@/admin/buckets/BucketsTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/buckets")({
    component: BucketsTable,
});
